import service from '@/services/SICUDgpd_inf_cont';

export default {
  namespaced: true,

  actions: {
    /**
     * Petición para obtener labels registrados en Integrity que serán utilizados en una vista.
     */
    async update({ dispatch, rootGetters }, event) {
      return new Promise((resolve, reject) => {
        const payload = {
          dsSICUDgpd_inf_cont: {
            eeDatos: [rootGetters['auth/state']],
            eegpd_inf_cont: [
              {
                doc_num: rootGetters['SICUDgpd_est_crd/state'].numberDocument || 0, // default,
                piindicador: 0,
                inf_bar: event.step2.inf_bar,
                inf_dir: event.step2.address || event.step2.inf_dir,
                ciu_cod: event.step2.ciu_cod?.[0]?.ciu__cod || event.step2.ciu_cod,
                inf_estr: event.step2.inf_estr?.[0]?.lis_det_par || event.step2.inf_estr,
                inf_tip: event.step2.inf_tip?.[0]?.lis_det_par || event.step2.inf_tip,
                inf_zon: event.step2.inf_zon?.[0]?.lis_det_par || event.step2.inf_zon,
              },
            ],
          },
        };

        let notification;

        service[event?.method || 'post'](payload)
          .then((response) => {
            const data = response.data.dsSICUDgpd_inf_cont;

            if (data.eeEstados[0].Returnid === 0) {
              resolve(data.eegpd_inf_cont[0]);
            } else if (data.eeEstados[0].Returnid === 98) {
              resolve([]);
            } else {
              notification = {
                code: data.eeEstados[0].Returnid,
                message: data.eeEstados[0].Estado,
                timestamp: Date.now(),
                type: 'error',
              };

              throw notification;
            }
          })
          .catch((error) => {
            if (error.type === undefined) {
              notification = {
                code: undefined,
                message: error.message,
                timestamp: Date.now(),
                type: 'error',
              };
            }

            dispatch('notification/create', notification, {
              root: true,
            });

            reject(notification);
          });
      });
    },
  },
};
